<!DOCTYPE html>
<div class="modal-wrapper">
  <img class="imgs" [src]="imageURL" alt="unsplash images" />
  @if (bottomBarToggle) {
    <div class="bottom-bar">
      <div class="toggle-warpper">
        <input
          id="toggle-remove"
          type="checkbox"
          (change)="RemoveImg(imageData)"
          />
          @if (showremoveAnimation) {
            <ng-lottie
              class="remove-animation"
              [options]="options"
            ></ng-lottie>
          }
          <label for="toggle-remove" class="heart-css"
            ><img src="../../../assets/icon/Group.svg"
          /></label>
        </div>
        <div class="toggle-warpper">
          <input
            id="toggle-heart"
            [checked]="imageData?.liked"
            type="checkbox"
            (change)="isChangeLimitAccessToggle($event.target.checked)"
            />
            @if (showAnimation) {
              <ng-lottie
                class="fav-animation"
                [options]="reaction_options"
              ></ng-lottie>
            }
            <label for="toggle-heart" class="heart-css"
              ><ion-icon name="heart" class="heart-icon"></ion-icon
            ></label>
          </div>
        </div>
      }
      @if (confirmRemoveImg) {
        <div
          class="confirmationPopup"
          [ngStyle]="{'width.px': getWidth()}"
          [ngClass]="removePopup ? 'android-popup' : 'ios-popup' "
          >
          <div class="top-wapper">
            <div class="text">
              <span [innerHTML]="'Lifestyle.sure' | translate"></span>
            </div>
            <div class="remove">
              <button (click)="RemoveImg(imageData)">
                {{ "Lifestyle.remove" | translate }}
              </button>
            </div>
          </div>
          <div class="cancle">
            <button (click)="close() ">{{ "Lifestyle.cancel" | translate }}</button>
          </div>
        </div>
      }
    </div>
